const React = require('react');
const PropTypes = require('prop-types');

const { connect } = require('react-redux');


const { formatText, getLanguage } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { getChosenDeferralText, getDeferralMonthsText, isLavandaCard } = require('utilities/lavandaHelper');

const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

const { ACCOUNT_PURCHASE_PAYMENT } = require('constants/operationTypes');
const { API_CENTER, API_ENTERPRISE_NUMBER } = require('constants/index')
const { ONE_QUOTA } = require('constants/lavanda');

const { LAVANDA } = require('constants/flagBasedFeatures');
//const AccountPaymentPurchaseDeferralActions = require('actions/accountPaymentPurchaseDeferral');

const TRANSLATION_KEY_PREFIX = 'accountPaymentPurchaseDeferralStep-';
const PAY_LATER = 'pago_facil_paga_despues';
const NOMINAL = 'nominal';
const TAE = 'tae';
const TIN = 'tin';
class ConfirmationPurchaseDeferral extends React.PureComponent {

    constructor(props){
        super(props)

        this.buildInformation = this.buildInformation.bind(this)
        this.buildSignature = this.buildSignature.bind(this)
    }

    buildSignature(){
        const { immCard, immAccount, immMovement } = this.props
        const params = {
            ammount : immMovement.get('balance').get('amount'),
            currency:  immMovement.get('balance').get('currency'),
            pan: immCard.get('number'),
            destinationAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${immAccount.get('product')}${immAccount.get('contractNumber')}`
        }

        return (
            <SignaturePattern
                operationType={ACCOUNT_PURCHASE_PAYMENT}
                operationParams={params}
            />
        )
    }


   buildInformation(){
        const {
            chosenDeferral,
            immCard,
            immLavanda,
            immMovement,
            lavandaEnabled,
            parameters,
            step,
        } = this.props;
        const financedPurchasedAmount = immMovement.get('balance');
        const operationDate = DateHelper.formatDate(immMovement.get('date'));
        const operationTime = immMovement.get('time') && DateHelper.formatDate(immMovement.get('time'));
        const plainAmountObject = getPlainAmountObject(financedPurchasedAmount);
        const totalInterests = getPlainAmountObject(step.get('interests'))
        const operationDescription = immMovement.get('description')
        const numberQuotas = step.get('currentQuota')
        const mensualQuota = getPlainAmountObject(step.get('quotaMonthly'))
        const totalAmount = getPlainAmountObject(step.get('totalAmount'))

        const isPack = immCard.get('isDiamond') || immCard.get('isPremium')
        let keyParam = isPack ? (immCard.get('isDiamond') ? 'pack_diamond' : 'pack_premium') : 'open_credit';

        const interestMn = parameters && parameters.getIn([keyParam, PAY_LATER, NOMINAL]);
        const isLavandaFlow = lavandaEnabled && isLavandaCard(immCard.get('product'), immLavanda.get('cards'));
        const language = getLanguage();
        let interestTae, interestTin = '-';
        let content;

        if(isLavandaFlow){
            if (!!chosenDeferral){
                if ( chosenDeferral === ONE_QUOTA){
                    interestTae = formatText('lavanda-lavanda_oneQuotaTae');
                    interestTin = formatText('lavanda-lavanda_oneQuotaTin');
                }else{
                    interestTae = parameters && parameters.getIn([keyParam, PAY_LATER, TAE]);
                    interestTin = parameters && parameters.getIn([keyParam, PAY_LATER , TIN]);
                }
            }
        }else {
            interestTae = parameters && parameters.getIn([keyParam, PAY_LATER, TAE]);
            interestTin = parameters && parameters.getIn([keyParam, PAY_LATER , TIN]);
        }

        if (isLavandaFlow) {
            const deferralMonthsText = getDeferralMonthsText(numberQuotas);
            const deferral = getChosenDeferralText(chosenDeferral);
            
            content = (
                <OKInformativeList columns={2}>
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'financedPurchasedAmount'}
                    >
                        <OneLineSymbolAmount
                            positiveAmount
                            className="card-payment-purchase-deferral-step__amount"
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                        />
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'tae'}
                        bodyText={interestTae}
                        isDarkTitle={true}
                    />
                    <OKInformativeListItem
                        bodyWordBreak={false}
                        title={TRANSLATION_KEY_PREFIX + 'description'}
                        bodyText={operationDescription}
                    />
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'tin'}
                        bodyText={interestTin}
                    />
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'operationDate'}
                        bodyText={operationDate}
                    />
                    <OKInformativeListItem
                        title="lavanda-lavanda_purchaseNature"
                        bodyText="lavanda-lavanda_paymentDeferral"
                    />
                    <OKInformativeListItem
                        title="lavanda-lavanda_deferralDuration"
                        bodyText={deferralMonthsText}
                    />
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'mensualQuota'}
                    >
                        <OneLineSymbolAmount
                            positiveAmount
                            className="card-payment-purchase-deferral-step__amount"
                            amountObject={mensualQuota}
                            language={language}
                            amountObjectFormatted={formatAmountObject(mensualQuota, true)} />
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title="lavanda-lavanda_chosenDeferral"
                        bodyText={deferral}
                    />
                    <OKInformativeListItem
                        title={"lavanda-lavanda_creditAmount"}
                    >
                        <OneLineSymbolAmount
                            positiveAmount
                            className="card-payment-purchase-deferral-step__amount"
                            amountObject={totalAmount}
                            language={language}
                            amountObjectFormatted={formatAmountObject(totalAmount, true)} />
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'numberQuotas'}
                        bodyText={`${numberQuotas}`}
                    />
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'totalInterests'}
                    >
                        <OneLineSymbolAmount
                            positiveAmount
                            className="card-payment-purchase-deferral-step__amount"
                            amountObject={totalInterests}
                            language={language}
                            amountObjectFormatted={formatAmountObject(totalInterests, true)} />
                    </OKInformativeListItem>
                </OKInformativeList>
            )
        } else{
            content = (
                <OKInformativeList columns={2}>
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'financedPurchasedAmount'}
                    >
                        <OneLineSymbolAmount
                            positiveAmount
                            className="card-payment-purchase-deferral-step__amount"
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'tae'}
                        bodyText={interestTae}
                    />
                    <OKInformativeListItem
                        bodyWordBreak={false}
                        title={TRANSLATION_KEY_PREFIX + 'description'}
                        bodyText={operationDescription}
                    />
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'tin'}
                        bodyText={interestTin}
                    />
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'operationDate'}
                        bodyText={operationDate}
                    />
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'monthlyNominal'}
                        bodyText={interestMn}
                    />
                    {operationTime &&
                        <OKInformativeListItem
                            title={TRANSLATION_KEY_PREFIX + 'operationTime'}
                            bodyText={operationTime}
                        />
                    }
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'totalInterests'}
                    >
                        <OneLineSymbolAmount
                            positiveAmount
                            className="card-payment-purchase-deferral-step__amount"
                            amountObject={totalInterests}
                            language={language}
                            amountObjectFormatted={formatAmountObject(totalInterests, true)} />
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'mensualQuota'}
                    >
                        <OneLineSymbolAmount
                            positiveAmount
                            className="card-payment-purchase-deferral-step__amount"
                            amountObject={mensualQuota}
                            language={language}
                            amountObjectFormatted={formatAmountObject(mensualQuota, true)} />
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'numberQuotas'}
                        bodyText={`${numberQuotas}`}
                    />
                    <OKInformativeListItem
                        title={TRANSLATION_KEY_PREFIX + 'totalAmount'}
                    >
                        <OneLineSymbolAmount
                            positiveAmount
                            className="card-payment-purchase-deferral-step__amount"
                            amountObject={totalAmount}
                            language={language}
                            amountObjectFormatted={formatAmountObject(totalAmount, true)} />
                    </OKInformativeListItem>
                </OKInformativeList>
            )
        }
        return content;
    }
    render() {
        return (
            <div className="accounts-payment-purchase-deferral__step accounts-payment-purchase-deferral__confirmation-step">
                <div className="accounts-payment-purchase-deferral__step__div-title">
                    <h3 className="accounts-payment-purchase-deferral__step__div-title__title print-title">{formatText("accountPaymentDeferral-confirmationTitle")}</h3>
                    <p className="accounts-payment-purchase-deferral__step__div-title__text">{formatText("accountPaymentDeferral-confirmationText")}</p>
                </div>
                <div className="accounts-payment-purchase-deferral__step__cards-content">
                    {this.buildInformation()}
                    {this.buildSignature()}
                </div>
            </div>
        )
    }
}

ConfirmationPurchaseDeferral.propTypes = {
    chosenDeferral: PropTypes.string,
    immMovement: PropTypes.object.isRequired,
    immAccountPaymentPurchaseDeferral: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    immLavanda: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    lavandaEnabled: PropTypes.bool,
    step: PropTypes.object,
    parameters: PropTypes.object.isRequired
};

module.exports.constructor = ConfirmationPurchaseDeferral;
module.exports.ConfirmationPurchaseDeferral = connect(
    state => ({
        immLavanda: state.cards.getIn(['credit','lavanda']),
        lavandaEnabled: state.flagBasedFeatures.get(LAVANDA),
        step: state.accountPaymentPurchaseDeferralReducer.getIn(['steps', 1, 'financingData']),
        chosenDeferral: state.accountPaymentPurchaseDeferralReducer.getIn(['steps', 1, 'chosenDeferral']),
        parameters: state.globalVariables.getIn(['variables', 'parameters']) || {}
    }))(ConfirmationPurchaseDeferral);
